import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';
import Loader from "../../components/Loader";
import axios from 'axios';
import Swal from 'sweetalert2';

const PasswordTab = ({ isActive }) => {
    const [loading, setLoading] = useState(false);
    const [new_password, setNewPassword] = useState('');
    const [confirm_password, setConfirmPassword] = useState('');
    const [showpasseye, setShowPassEye] = useState(false);
    const [showconfirmpasseye, setShowConfirmPassEye] = useState(false);
    const navigate = useNavigate();
    const ENDPOINT = process.env.REACT_APP_URL_ENDPOINT;
    const TITLEALERT = process.env.REACT_APP_TITLE_ALERT;

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const user = JSON.parse(localStorage.getItem('dataUser'));
        const user_id = user.user_id;
        await axios.put(ENDPOINT + 'change-password-user/' + user_id, {
            user_id: user_id,
            password: new_password,
            confirm_password: confirm_password
        }).then(response => {
            setLoading(false);
            setNewPassword('');
            setConfirmPassword('');
            Swal.fire({
                icon: 'success',
                title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                showConfirmButton: false,
                timer: 3000,
                html: '<div class="text-custom-alert">' + response.data.msg + '</div>',
                showClass: { popup: 'animate__animated animate__fadeInDown' },
                hideClass: { popup: 'animate__animated animate__fadeOutUp' }
            })
        }).catch(function (error) {
            console.log(error)
            setLoading(false);
            Swal.fire({
                icon: 'error',
                title: '<div class="title-custom-alert">TRANSPORTES VARAOR DE SALINA CRUZ</div>',
                showConfirmButton: true,
                timer: 3000,
                html: '<div class="text-custom-alert">' + error.response.data.msg + '</div>',
                showClass: { popup: 'animate__animated animate__fadeInDown' },
                hideClass: { popup: 'animate__animated animate__fadeOutUp' }
            })
        });
    }

    const showPassword = () => {
        setShowPassEye(!showpasseye);
    };

    const showConfirmPassword = () => {
        setShowConfirmPassEye(!showconfirmpasseye);
    };

    const goDashboard = () => {
        navigate('/dashboard');
    }

    return (
        <>
            {loading && <Loader />}
            <div className={`tab-pane ${isActive ? 'active' : ''}`}>
                <div className="row mb-4">
                    <div className="col-md-12">
                        <div className="title-form">
                            <h6 className="font-bold">
                                <i className="fas fa-key me-2"></i> 
                                Cambio de Contraseña
                            </h6>
                            <p className="text-muted font-size-sm mb-0">
                                Por seguridad, ingrese su contraseña actual y luego la nueva contraseña. Los campos marcados con (<span className="text-danger">*</span>) son obligatorios.
                            </p>
                        </div>
                        <hr className="my-2" />
                    </div>
                </div>

                <form onSubmit={handleSubmit} className="row">
                    <div className="col-12">
                        <div className="password-recommendations p-3 mb-4" style={{ 
                            background: '#f8f9fa', 
                            border: '1px solid #dee2e6',
                            borderRadius: '8px',
                            boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                        }}>
                            <h6 className="recommendations-title mb-3" style={{
                                color: '#033c73',
                                fontSize: '1rem',
                                fontWeight: '600'
                            }}>
                                <i className="fas fa-shield-alt me-2"></i>
                                Recomendaciones para una contraseña segura
                            </h6>
                            <div className="recommendations-list" style={{
                                display: 'grid',
                                gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                                gap: '10px'
                            }}>
                                <div className="recommendation-item" style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    fontSize: '0.875rem',
                                    color: '#495057'
                                }}>
                                    <i className="fas fa-check-circle me-2" style={{ color: '#28a745' }}></i>
                                    Al menos una letra mayúscula
                                </div>
                                <div className="recommendation-item" style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    fontSize: '0.875rem',
                                    color: '#495057'
                                }}>
                                    <i className="fas fa-check-circle me-2" style={{ color: '#28a745' }}></i>
                                    Al menos una letra minúscula
                                </div>
                                <div className="recommendation-item" style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    fontSize: '0.875rem',
                                    color: '#495057'
                                }}>
                                    <i className="fas fa-check-circle me-2" style={{ color: '#28a745' }}></i>
                                    Al menos un número
                                </div>
                                <div className="recommendation-item" style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    fontSize: '0.875rem',
                                    color: '#495057'
                                }}>
                                    <i className="fas fa-check-circle me-2" style={{ color: '#28a745' }}></i>
                                    Al menos un carácter especial
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-sm-6">
                        <div className="form-group">
                            <label htmlFor="new_password" className="col-form-label col-form-label-sm">
                                Nueva Contraseña <span className="text-danger">*</span>
                            </label>
                            <div className="position-relative">
                                <input
                                    type={!showpasseye ? 'password' : 'text'}
                                    className="form-control form-control-sm"
                                    placeholder="Ingrese nueva contraseña"
                                    id="new_password"
                                    name="new_password"
                                    onChange={(e) => setNewPassword(e.target.value)}
                                    value={new_password}
                                    required
                                />
                                <span 
                                    className="position-absolute" 
                                    style={{ 
                                        right: '10px', 
                                        top: '50%', 
                                        transform: 'translateY(-50%)', 
                                        cursor: 'pointer' 
                                    }} 
                                    onClick={showPassword}
                                >
                                    <i className={`fas ${!showpasseye ? 'fa-eye' : 'fa-eye-slash'}`} style={{ color: "#033c73" }}></i>
                                </span>
                            </div>
                            <small className="text-muted">Ingrese su nueva contraseña siguiendo las recomendaciones</small>
                        </div>
                    </div>

                    <div className="col-sm-6">
                        <div className="form-group">
                            <label htmlFor="confirm_password" className="col-form-label col-form-label-sm">
                                Confirmar Contraseña <span className="text-danger">*</span>
                            </label>
                            <div className="position-relative">
                                <input
                                    type={!showconfirmpasseye ? 'password' : 'text'}
                                    className="form-control form-control-sm"
                                    placeholder="Confirme nueva contraseña"
                                    id="confirm_password"
                                    name="confirm_password"
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                    value={confirm_password}
                                    required
                                />
                                <span 
                                    className="position-absolute" 
                                    style={{ 
                                        right: '10px', 
                                        top: '50%', 
                                        transform: 'translateY(-50%)', 
                                        cursor: 'pointer' 
                                    }} 
                                    onClick={showConfirmPassword}
                                >
                                    <i className={`fas ${!showconfirmpasseye ? 'fa-eye' : 'fa-eye-slash'}`} style={{ color: "#033c73" }}></i>
                                </span>
                            </div>
                            <small className="text-muted">Repita la nueva contraseña para confirmar</small>
                        </div>
                    </div>

                    <div className="form-group p-0 mt-4 mx-2">
                        <div className="text-right">
                            <button type='submit' className="btn btn-success btn-sm me-2">
                                <i className="fa-regular fa-floppy-disk me-2"></i> Actualizar Contraseña
                            </button>
                            <button onClick={goDashboard} type='button' className="btn btn-danger btn-sm">
                                <i className="fa-solid fa-ban me-1"></i> Cancelar
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </>
    );
};

export default PasswordTab;